import {
  Box,
  Container,
  Grid2,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Button
} from '@mui/material'
import { map } from 'lodash/fp'
// import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
// import { Loading } from "../Loading";
// import { useEffect } from "react";

export const Blockage = () => {
  const handleClick = () => {
    window.location.href = 'https://www.terashite.jp/'
  }
  const table = [
    { day: '月曜日', description: '24時間ご利用いただけます。' },
    { day: '火曜日～土曜日', description: '1時30分～24時' },
    { day: '日曜日', description: '0時～5時、6時～24時' }
  ]
  return (
    <Box>
      <Container maxWidth="xl">
        <Grid2 container>
          <Grid2 size={{ sm: 2 }} />
          <Grid2 size={{ lg: 8, sm: 8 }} spacing={10}>
            <Typography variant="h4" align='center'>
              ただいまシステムメンテナンス中です。
            </Typography>
            <Typography variant="body1" mt={2}>
              ご不便をおかけして大変申し訳ありませんが、サービスご利用可能時間に再度アクセスしてください。
            </Typography>
            <Typography variant="h5" mt={5} align="center">
              サービスご利用可能時間
            </Typography>
            <Box
              display={'flex'}
              justifyContent={'center'}
              flexDirection={'row'}
              mt={3}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: 'orange',
                          fontWeight: 'bold',
                          textAlign: 'center'
                        }}>
                        曜日
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: 'orange',
                          fontWeight: 'bold',
                          textAlign: 'center'
                        }}>
                        営業時間
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {map(
                      (
                        row: { day: string; description: string },
                        index: number
                      ) => (
                        <TableRow key={index}>
                          <TableCell
                            sx={{
                              backgroundColor: '#FFF3E0',
                              textAlign: 'center'
                            }}>
                            {row.day}
                          </TableCell>
                          <TableCell
                            sx={{
                              backgroundColor: '#FFF3E0',
                              textAlign: 'center'
                            }}>
                            {row.description}
                          </TableCell>
                        </TableRow>
                      )
                    )(table)}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box mt={5}>
              <Typography variant="caption">
                ※なお、ご利用時間内であっても臨時のシステムメンテナンスなどにより、
                サービスをご利用いただけない場合がございますので予めご了承ください。
              </Typography>
            </Box>
            <Box display={'flex'} justifyContent={'space-around'} mt={5}>
              <Button variant="contained" color="primary" onClick={handleClick}>
                テラシテトップに戻る
              </Button>
            </Box>
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  )
}
